import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";
import type { Device } from "@/types";

export const usePlayerState = () => {
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
    const [brightness, setBrightness] = useState(100);
    const [deviceId, setDeviceId] = useState("");
    const [showWeatherClock, setShowWeatherClock] = useState(false);
    const [showNewsTicker, setShowNewsTicker] = useState(false);
    const [organizationId, setOrganizationId] = useState<string | null>(null);

    useEffect(() => {
        let storedDeviceId = localStorage.getItem("deviceId");
        if (!storedDeviceId) {
            storedDeviceId = `device-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem("deviceId", storedDeviceId);
        }
        setDeviceId(storedDeviceId);

        const savedBrightness = localStorage.getItem("brightness");
        if (savedBrightness) setBrightness(parseInt(savedBrightness));
        const savedWeatherClock = localStorage.getItem("showWeatherClock");
        if (savedWeatherClock) setShowWeatherClock(JSON.parse(savedWeatherClock));
        const savedNewsTicker = localStorage.getItem("showNewsTicker");
        if (savedNewsTicker) setShowNewsTicker(JSON.parse(savedNewsTicker));

        // Carregar organization_id do device usando o código do dispositivo da sessão
        const loadDeviceOrganization = async () => {
            try {
                // Primeiro tentar obter o código do dispositivo da sessão
                let deviceCode = sessionStorage.getItem('player_device_code');

                // Se não encontrar na sessão, tentar no localStorage
                if (!deviceCode) {
                    deviceCode = localStorage.getItem('deviceCode');
                }

                if (!deviceCode) {
                    console.log('❌ Código do dispositivo não encontrado na sessão ou localStorage');
                    return;
                }

                console.log('🔍 [PLAYER_STATE] Carregando organização para código:', deviceCode);

                // Buscar o device pelo código formatado
                const { data, error } = await supabase
                    .from('devices')
                    .select('organization_id')
                    .eq('code', deviceCode.toUpperCase())
                    .maybeSingle();

                if (error) {
                    console.error('❌ [PLAYER_STATE] Erro ao carregar organização do dispositivo:', error);
                    return;
                }

                if (data?.organization_id) {
                    console.log('✅ Organization ID carregado:', data.organization_id);
                    setOrganizationId(data.organization_id);
                    localStorage.setItem("organizationId", data.organization_id);
                } else {
                    console.log('❌ Nenhuma organização encontrada para o código:', deviceCode);
                }
            } catch (error) {
                console.error('Erro ao carregar organização:', error);
            }
        };

        loadDeviceOrganization();
    }, []);

    const saveBrightness = (value: number) => {
        setBrightness(value);
        localStorage.setItem("brightness", value.toString());
    };

    return {
        isSettingsOpen,
        setIsSettingsOpen,
        currentMediaIndex,
        setCurrentMediaIndex,
        brightness,
        saveBrightness,
        deviceId,
        showWeatherClock,
        setShowWeatherClock,
        showNewsTicker,
        setShowNewsTicker,
        organizationId
    };
};
